import React, { useMemo } from 'react';
import { Button, NumberField, StyledWrapper, TextField } from 'ui-toolkit';
import { Form, Formik } from 'formik';
import { DateRangeFilter } from 'ui-toolkit/components/DataGrid/DateRangeFilter';
import { StyledTableRow } from './MatchedActualStyles';
import { IEscrowActualIncomingWireQuery } from 'types/accounting/query/IEscrowActualIncomingWireQuery';

interface IMatchActualWireDepositSearchBarProps {
  setQuery: (query: IEscrowActualIncomingWireQuery) => void;
  query: IEscrowActualIncomingWireQuery;
}
export const MatchActualWireDepositSearchBar: React.FC<IMatchActualWireDepositSearchBarProps> = ({
  setQuery,
  query,
}) => {
  const initialValues = useMemo(() => {
    return {
      createdAtDate: query.completedAtDate,
      obi: query.obi,
      sender: query.org,
      received: query.amountCents,
      unmatched: query.unmatchedAmountCents,
    };
  }, [query]);

  const onSubmit = (values: any) =>
    setQuery({
      ...query,
      completedAtDate: values.createdAtDate ?? undefined,
      obi: values.obi ?? undefined,
      org: values.sender ?? undefined,
      amountCents: values.received ?? undefined,
      unmatchedAmountCents: values.unmatched ?? undefined,
    });

  const updateDateRange = (newDate: any, setFieldValue: any) => {
    setFieldValue('createdAtDate', newDate);
  };

  return (
    <StyledWrapper>
      <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
        {({ handleSubmit, values, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <StyledTableRow columnsLength={6}>
              <DateRangeFilter
                defaultValue={values.createdAtDate}
                onFilter={(value) => updateDateRange(value, setFieldValue)}
                showClear
                fixed
              />
              <TextField name={`obi`} placeholder={'OBI'} />
              <TextField name={`sender`} placeholder={'Sender'} />
              <NumberField name={`received`} mode="currency" placeholder="Received" valueIsCents />
              <NumberField name={`unmatched`} mode="currency" placeholder="Unmatched" valueIsCents />
              <Button intent={'primary'} type={'submit'} data-test-id={`search-button`}>
                Search
              </Button>
            </StyledTableRow>
          </Form>
        )}
      </Formik>
    </StyledWrapper>
  );
};
